"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleOrder = void 0;
const React = require("react");
const react_1 = require("react");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const useRetailLocationAvailability_1 = require("../../hooks/useRetailLocationAvailability");
const ScheduleSalesOrderModal_1 = require("../../modals/ScheduleSalesOrderModal");
const SalesOrderContext_1 = require("../../contexts/SalesOrderContext");
const Icon_1 = require("../../../../../components/base/atoms/Icon");
const colors_1 = require("../../../../../types/colors");
const constants_1 = require("../../../../../helpers/constants");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ScheduleOrder");
const ScheduleOrder = ({ onScheduledTimeChange }) => {
    const { retailLocation } = (0, useRequiredContext_1.useRequiredContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { requestedReadyTime } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const { allowedOrderTimes } = (0, useRetailLocationAvailability_1.useRetailLocationAvailability)(retailLocation);
    const [showRequestedReadyTimeSelect, setShowRequestedReadyTimeSelect] = (0, react_1.useState)(false);
    const requestedReadyTimeLabel = (0, useRetailLocationAvailability_1.useRequestedReadyTimeLabel)(retailLocation, requestedReadyTime, constants_1.humanTimeFormat);
    const showRequestedReadyTimeSelectModal = (0, react_1.useCallback)(() => {
        // show time select modal
        setShowRequestedReadyTimeSelect(true);
    }, [requestedReadyTime, allowedOrderTimes]);
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("container") },
            React.createElement(Icon_1.Icon, { className: css("schedule"), name: "clock-o", variant: colors_1.TColorVariants.Danger }),
            React.createElement("div", { className: css("label") }, requestedReadyTimeLabel),
            React.createElement("a", { className: css("changeReadyTime"), onClick: showRequestedReadyTimeSelectModal }, "schedule")),
        React.createElement(ScheduleSalesOrderModal_1.ScheduleSalesOrderModal, { open: showRequestedReadyTimeSelect, setOpen: setShowRequestedReadyTimeSelect, onScheduledTimeChange: onScheduledTimeChange })));
};
exports.ScheduleOrder = ScheduleOrder;
//# sourceMappingURL=index.js.map